import React, { useContext, useState, useEffect } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import Autocomplete from '../common/AutocompleteAddress.jsx';
import requests from '../utils/requests.js';
import { s } from '../Style.jsx';
import StyledInput from '../common/StyledInput.jsx';
import functions from '../utils/functions.js';

const Account = () => {

    const { setPerson, auth, user, person } = useContext(PersonContext);

    const [editingPerson, setEditingPerson] = useState({});

    useEffect(() => {
        if (person) setEditingPerson(person);
    }, [person]);

    const signOut = async () => {
        await auth.signOut(auth);
        window.location.href = "/";
    };

    return <>
        <div style={s.headerBox}>
            <div style={s.headerInnerBox}>
                <div style={s.row}>
                    <h1 style={{ marginBottom: 0 }}>My Account</h1>
                    <button style={s.button} onClick={signOut}>Sign Out</button>
                </div>
            </div>
        </div>
        <div style={s.paddingContainer}>
            <div style={s.mobileContainer}>

                {!person?.phone && <i className={"fas fa-spinner fa-spin"}></i>}

                {person?.phone && <>
                    <h2 style={{ fontSize: 28, fontWeight: "initial", marginBottom: 40 }}>Hi, <StyledInput placeholder="Your Name" style={{ fontWeight: "bold", fontSize: 28, display: "inline-block", width: 200 }} value={editingPerson?.name} onChange={e => setEditingPerson({ ...editingPerson, name: e })} /></h2>

                    <h3>Phone Number</h3>
                    <span>{functions.formatPhone(user?.phoneNumber)}</span>

                    <h3>Current Address</h3>
                    <Autocomplete value={editingPerson?.address} width="100%" onChange={e => setEditingPerson({ ...editingPerson, address: e })} />
                </>}

                {person?.phone && (JSON.stringify(person) !== JSON.stringify(editingPerson)) && <div style={{...s.row, marginTop: 20, justifyContent: "flex-end"}}>
                    <button style={s.button} onClick={() => setEditingPerson(person)}>Cancel Changes</button>
                    <button style={s.button} onClick={() => {
                        setPerson(editingPerson);
                        requests.updatePerson(auth, { address: editingPerson.address, name: editingPerson.name }, person.id);
                    }}>Save Changes</button>
                </div>}

            </div>
        </div>
    </>;
}
export default Account;
